import { render } from "./ChartList.vue?vue&type=template&id=c642705e"
import script from "./ChartList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartList.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Insights/ChartList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c642705e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c642705e', __exports__)) {
    api.reload('c642705e', __exports__)
  }
  
  module.hot.accept("./ChartList.vue?vue&type=template&id=c642705e", () => {
    api.rerender('c642705e', render)
  })

}


export default __exports__